var audio_rtlignore_default = {
  "fontElementMap": "qdvcc",
  "container": "GORLK",
  "customPlayer": "WkTjb",
  "slim": "WdKm-",
  "playPauseButton": "FISeD",
  "coverImage": "ONzxT",
  "trackDetailsContainer": "_9G1qg",
  "controlsContainer": "xo76T",
  "controlsGroup": "mWJMx",
  "sliderContainer": "VVfz4",
  "audioDuration": "_6LuAr",
  "isLoading": "leVyk",
  "audioDetails": "_7Pu1W",
  "authorName": "_92BRV",
  "title": "gEPTK",
  "dropdownMenuWrapper": "_2q0xK",
  "dropdownSelectedButton": "_-7PKv",
  "dropdownContent": "Zh9M2",
  "dropdownContentWithIcon": "DfnDw",
  "audioLoader": "amO3w"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
